function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import classNames from 'classnames';
import { useMediaIsDesktop } from '@collaborator/npm_modules/dist/components/media';

var Menu = function Menu(_ref) {
  var block = _ref.block,
      hide = _ref.hide,
      itemClassName = _ref.itemClassName;
  var isDesktop = useMediaIsDesktop();
  var items = React.useMemo(function () {
    return block.items.filter(function (item) {
      return !isDesktop || isDesktop && item.isVisibleDesktop;
    });
  }, [block.items, isDesktop]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (menuItem) {
    return /*#__PURE__*/React.createElement("div", {
      key: menuItem.label,
      className: classNames('dropdown-flat-list__item', itemClassName)
    }, /*#__PURE__*/React.createElement(MenuItem, _extends({}, menuItem, {
      onClick: function onClick() {
        hide();
      }
    })));
  }));
};

export { Menu };